var map = {
	"./development": 1747,
	"./development.js": 1747,
	"./preprod": 51966,
	"./preprod.js": 51966,
	"./production": 16391,
	"./production.js": 16391,
	"./qa": 98114,
	"./qa.js": 98114,
	"./staging": 82515,
	"./staging.js": 82515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20316;